export const veridionPageFR = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | L’organisation de collaborateurs IA",
    "description": "Le prochain palier de productivité : l’Organisation as a Service. Une organisation de collaborateurs IA livre un travail vérifié, planifiable en cycles fixes, sur site ou dans votre propre cloud."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Un créateur, une infinité de solutions.",
    "claim": "Le prochain palier de productivité : l’Organisation as a Service.",
    "lead": "L’IA d’entreprise qui pilote toute la pAIoneer Labs GmbH : un effectif de collaborateurs IA qui s’intègre à chaque processus de votre entreprise, mène le travail à son terme de façon autonome et apprend à chaque tâche. Les humains donnent la direction. Tout le reste se fait de lui-même."
  },
  "vision": {
    "lines": [
      "Le logiciel a donné aux entreprises des outils.",
      "L’IA leur a donné des assistants.",
      "Veridion leur donne une organisation."
    ],
    "note": "L’information circule en quelques heures, l’expérience part à la retraite, les postes restent vacants. Un outil de plus ne règle pas cela ; un effectif qu’on n’a pas besoin d’embaucher le règle."
  },
  "grow": {
    "title": "Ce qu’il ne sait pas faire, il le crée",
    "text": "Lorsqu’aucune capacité n’existe encore pour une tâche ou qu’un problème ne peut pas être résolu avec les moyens existants, Veridion développe elle-même de nouveaux systèmes d’IA arbitrairement complexes — l’IA fait évoluer l’IA de manière autonome : conçus, construits, vérifiés et mis en service. Seule la validation finale reste auprès de l’humain via l’[Intent-Driven Development](idd) (IDD).",
    "punch": "C’est exactement cela : un créateur, une infinité de solutions."
  },
  "integrate": {
    "title": "Au cœur de vos processus",
    "subtitle": "Pas de nouveau logiciel, pas de formation, pas de migration.",
    "cards": [
      {
        "title": "Dans le chat d’entreprise",
        "text": "La conversation se tient là où vos équipes écrivent déjà : Webex, Microsoft Teams, Zoom, Slack. Un message suffit."
      },
      {
        "title": "Dans vos outils",
        "text": "Gestion de projet, dépôts de code, archivage : le travail se fait dans les systèmes déjà en place, sans les contourner."
      },
      {
        "title": "De l’offre à la comptabilité",
        "text": "Un processus après l’autre, à votre rythme. Quand les capacités viennent à manquer, ce peut être aussi un seul lot de développement ou un projet entier."
      }
    ]
  },
  "org": {
    "title": "Un effectif organisé comme une entreprise",
    "subtitle": "Nous n’imposons aucun modèle figé : pour chaque structure d’entreprise, nous concevons un organigramme sur mesure, attribuons des rôles et des responsabilités clairs et nous adaptons avec souplesse. Chaque Business Unit est composée de collaborateurs IA orchestrés par Veridion qui travaillent de façon entièrement automatisée jusqu’au [IDD](idd) Human-in-the-Loop — et lorsque quelque chose n’est pas encore possible, Veridion développe elle-même une nouvelle IA.",
    "execKicker": "Niveau de coordination — entièrement automatisé jusqu’à l’IDD Human-in-the-Loop",
    "execTitle": "Organigramme sur mesure, rôles clairs et une IA qui fait évoluer l’IA elle-même.",
    "execText": "Sous la direction des décideurs humains, le niveau de coordination et les Business Units de collaborateurs IA fonctionnent de manière entièrement automatisée : ils décomposent les objectifs, répartissent le travail selon des rôles et responsabilités clairement définis, résolvent les problèmes en autonomie et sollicitent des validations ciblées auprès de l’humain. L’humain dans la boucle pilote via l’[Intent-Driven Development](idd) (IDD) — bien au-delà du code logiciel, comme pilotage conjoint de l’humain et de l’IA par les intentions, les décisions et les scénarios de vérification. Et dès qu’une capacité manque, Veridion conçoit et construit de nouveaux systèmes d’IA arbitrairement complexes — l’IA développe l’IA.",
    "units": [
      {
        "name": "Développement logiciel",
        "text": "Répond du logiciel de l’exigence à l’exploitation : architecture, code, tests, revues, pipelines et la qualité derrière tout cela."
      },
      {
        "name": "Électronique & firmware",
        "text": "Répond du versant matériel : les circuits, le firmware et le choix de chaque composant."
      },
      {
        "name": "Informatique quantique & IA quantique",
        "text": "Répond de la recherche en informatique quantique et en IA quantique et transforme les résultats solides en produits."
      },
      {
        "name": "Ventes & marketing",
        "text": "Répond du marché : l’observe, repère les clients cibles, établit des dossiers, rédige des textes et des offres. La conclusion de l’affaire revient à un humain."
      },
      {
        "name": "Produits & exploitation de la plateforme",
        "text": "Répond des produits et de l’exploitation : stratégie, priorités, releases, ainsi que la surveillance, les incidents et la capacité de la plateforme en service."
      },
      {
        "name": "Administration & finances",
        "text": "Répond de la gestion administrative et comptable : justificatifs, factures, contrats, échéances, préparés jusqu’à la signature, qui reste entre vos mains."
      }
    ]
  },
  "trust": {
    "title": "Ce sur quoi vous pouvez compter",
    "cards": [
      {
        "title": "Human-in-the-Loop & l’IDD bien au-delà du code",
        "text": "L’Intent-Driven Development ([IDD](idd)) va bien au-delà du code informatique : c’est ce que l’humain dans la boucle réalise avec l’IA dans tous les domaines de l’entreprise. L’humain et l’IA formulent ensemble l’intention (Intent), arrêtent les décisions engageantes (Decisions) et définissent les scénarios vérifiables (Scenarios) avant que les collaborateurs IA n’exécutent le travail en cycles fixes et planifiables sous validation humaine."
      },
      {
        "title": "Communication optimisée par la théorie des jeux",
        "text": "La gestion de projet et la communication des collaborateurs IA sont optimisées par la théorie des jeux, du collaborateur IA individuel à toute la business unit : la rigueur et l’objection argumentée paient ; approuver sans examiner, se répéter et se renvoyer la responsabilité coûtent. C’est ainsi que la meilleure communication s’impose."
      },
      {
        "title": "Explicable jusqu’à la source",
        "text": "L’Explainable AI est ici le principe de travail, pas un supplément : chaque résultat met au jour ce dont il est issu, les passages trouvés dans le savoir de l’entreprise, les données, le chemin de calcul. Ce qui n’a pas de preuve n’est pas affirmé."
      },
      {
        "title": "Apprend par lui-même",
        "text": "Ses propres indicateurs sont lus après chaque passage, ses propres règles ajustées en conséquence : chaque projet en cours rend l’ensemble meilleur."
      }
    ]
  },
  "daily": {
    "title": "Ce qui est déjà pris en charge aujourd’hui",
    "subtitle": "Chaque jour, à travers toute l’entreprise.",
    "items": [
      {
        "title": "Développement",
        "text": "Code, tests et documentation à partir de décisions consignées. Modernisation de logiciels historiques avec preuve golden master et back-to-back."
      },
      {
        "title": "Électronique & firmware",
        "text": "Analyser les fiches techniques, simuler les circuits en jumeaux numériques, développer le firmware et évaluer les alternatives de composants avant toute fabrication, au plus près du matériel jusqu’au capteur."
      },
      {
        "title": "Recherche quantique",
        "text": "Lire l’état de l’art, construire et évaluer des expériences reproductibles contre des bases de comparaison classiques, chaque résultat consigné de façon traçable."
      },
      {
        "title": "Analyse de données",
        "text": "SQL Server, MariaDB, MySQL et Oracle : plan d’analyse typé, requêtes strictement en lecture, statistiques calculées par l’environnement d’exécution, rapports issus d’un seul résultat versionné."
      },
      {
        "title": "Administration & finances",
        "text": "Comptabilité, gestion financière et la bureaucratie d’une société : lire, imputer et archiver les justificatifs ; projets de factures et de contrats inclus."
      },
      {
        "title": "Projets & tâches",
        "text": "Une transcription de réunion devient sans détour des tâches dans la gestion de projet, et l’avancement remonte : la réunion suivante part de l’état actuel."
      },
      {
        "title": "Savoir de l’entreprise",
        "text": "Une base de connaissances pour les documents et une base de données en graphe qui relie tâches, décisions, personnes et systèmes : le contexte sur des semaines et par-delà les projets."
      },
      {
        "title": "Recherche sur Internet",
        "text": "Ce que le savoir de l’entreprise ne contient pas est recherché : les meilleures pages sont trouvées et lues, et à la fin se tient un rapport où chaque affirmation a sa source numérotée."
      },
      {
        "title": "Voix & réunions",
        "text": "Toute l’entreprise se pilote en mobilité : les conversations parlées font le même travail que le chat, aussi au téléphone en déplacement."
      },
      {
        "title": "Travail de bureau avec RoBuddy",
        "text": "RoBuddy couvre le poste de travail : rendez-vous, e-mails, formations et questions de protection des données. Les unités couvrent le reste de l’entreprise."
      }
    ]
  },
  "operate": {
    "title": "Exploitation",
    "cards": [
      {
        "title": "Sur site ou dans votre propre cloud",
        "text": "En amont, nous calculons ensemble quels processus sont rentables : le retour sur investissement et le coût total sont posés sur la table. L’exploitation se fait sur votre matériel ou dans votre propre cloud, sans qu’aucun document ne quitte la maison."
      },
      {
        "title": "Chez nous",
        "text": "La pAIoneer Labs GmbH est bâtie ainsi de fond en comble : nos projets, notre savoir d’entreprise et notre administration tournent dessus. L’organisation développe elle-même l’[assistant de trading](finance) de notre plateforme et en est l’IA dans le chat."
      }
    ]
  },
  "cta": {
    "title": "Demande",
    "subtitle": "Sous forme de logiciel serveur dans votre infrastructure. Le prix est communiqué sur demande.",
    "button": "Envoyer la demande",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
